{
  "header": {
    "nav": {
      "services": "Servicios",
      "products": "Productos",
      "security": "Seguridad",
      "process": "Proceso",
      "contact": "Contacto"
    },
    "cta": "Hablemos",
    "brand_aria": "Niertech Solutions",
    "nav_aria": "Principal"
  },
  "hero": {
    "eyebrow": "Niertech Solutions",
    "title": "Desarrollo de software y consultoría TI para equipos que no aceptan improvisación.",
    "subtitle": "Entregamos sistemas a medida, infraestructura, seguridad de la información e inteligencia de datos — con la seriedad que exigen los proyectos corporativos y del sector público.",
    "cta_primary": "Hablar con el equipo",
    "cta_secondary": "Nuestros servicios",
    "stack_aria": "Stack"
  },
  "pillars": {
    "eyebrow": "Nuestros servicios",
    "title": "Tecnología desde el alcance hasta el deploy — todo bajo el mismo techo.",
    "lead": "Somos una empresa de tecnología enfocada en ofrecer soluciones de alta calidad a empresas de diversos sectores, con la confiabilidad que los proyectos serios exigen.",
    "items": {
      "consulting": {
        "title": "Consultoría TI",
        "body": "Asesoría estratégica para optimizar procesos, evaluar el stack y orientar decisiones tecnológicas — desde el roadmap hasta el modelo operativo."
      },
      "dev": {
        "title": "Desarrollo de Software",
        "body": "Sistemas web y mobile a medida con los stacks más modernos. Del alcance funcional al deploy en producción, con documentación y pruebas."
      },
      "infra": {
        "title": "Infraestructura TI",
        "body": "Cloud computing, servidores, redes y aprovisionamiento. Arquitectura escalable, monitoreo, backups y continuidad operativa."
      },
      "outsourcing": {
        "title": "Outsourcing TI",
        "body": "Asignación de profesionales especializados a proyectos de corto o largo plazo — con gestión técnica y SLAs definidos."
      },
      "security": {
        "title": "Seguridad de la Información",
        "body": "Protección de datos en cumplimiento con LGPD, GDPR y normas internacionales. Políticas, auditorías, control de acceso y respuesta a incidentes."
      },
      "bi": {
        "title": "Business Intelligence",
        "body": "Dashboards, reportes e integraciones que transforman datos en insight estratégico. Indicadores operativos accionables, no solo gráficos."
      }
    }
  },
  "projects": {
    "eyebrow": "Productos",
    "title": "Sistemas reales, en producción.",
    "lead": "Dos productos principales enfocados en el sector público, apoyados por una línea de aplicaciones corporativas que cubre CRM, comunicación e inteligencia de datos.",
    "flagships": {
      "siplanp": {
        "tag": "Gestión Pública",
        "name": "SIPLANP",
        "subtitle": "Sistema de Planificación y Gestión Pública",
        "desc": "Plataforma SaaS multi-tenant creada para que organismos públicos reemplacen planillas y procesos fragmentados. Kanban, formularios dinámicos, chat interno, calendario y módulos verticales acoplados según la licitación.",
        "features": [
          "Multi-tenant con aislamiento por cliente",
          "Control de acceso por perfil y sector",
          "Módulos verticales acoplables (ingeniería, catálogo, flujos)",
          "Exportación, auditoría y logs completos",
          "Interfaz web responsive, sin instalación"
        ]
      },
      "ntnutri": {
        "tag": "Alimentación Escolar",
        "name": "NtNutri",
        "subtitle": "Gestión de Alimentación y Nutrición Escolar",
        "desc": "SaaS adherente a la Resolución FNDE y a la Ley PNAE de Brasil, listo para dispensa electrónica y licitación. Planifica menús, calcula cantidades, consolida la pauta de licitación, controla stock y genera la rendición de cuentas FNDE sin re-digitación.",
        "features": [
          "Elaboración de menús con per cápitas",
          "Cálculo automático de cantidades",
          "Pauta de licitación consolidada",
          "Saldos de stock y movimiento de alimentos",
          "30% agricultura familiar (Ley 11.947/2009)",
          "Exportación al FNDE y reportes gerenciales",
          "LGPD, perfiles de acceso, transparencia activa"
        ]
      }
    },
    "products": {
      "nierbusyness": {
        "tag": "CRM Corporativo",
        "name": "NierBusyness",
        "desc": "CRM end-to-end para la rutina comercial: captación y calificación de leads, pipeline de ventas, propuestas, contratos, firma digital y seguimiento postventa. Integra con ERP, e-mail y WhatsApp para centralizar todo el contacto con el cliente."
      },
      "yorwha": {
        "tag": "Inbox Multicanal",
        "name": "Yorwha",
        "desc": "Plataforma multicanal de mensajería para PyMEs: WhatsApp Business, Instagram Direct, Facebook Messenger, TikTok DM, SMS, e-mail y Telegram en una única bandeja de entrada. Colas, RBAC, MFA (TOTP), templates, reacciones, adjuntos y llamadas. Conformidad GDPR/LGPD/CPRA — credenciales cifradas en reposo (AES-256-GCM), endpoints de exportación y eliminación de datos, políticas formales de respuesta a incidentes y control de acceso."
      },
      "magnum": {
        "tag": "Analytics y SCADA",
        "name": "Magnum",
        "desc": "Plataforma de analytics y supervisión en tiempo real. Dashboards ejecutivos, KPIs operativos, alertas por regla, integración con fuentes heterogéneas (SQL, APIs, CSV, IoT) e historial consolidado para decisiones basadas en datos — del piso de planta a la dirección."
      }
    }
  },
  "security": {
    "eyebrow": "Seguridad y Cumplimiento",
    "title": "La seguridad no es un checklist — es cómo construimos.",
    "lead": "Cada sistema que entregamos es defensivo por defecto: cifrado en reposo, autenticación multifactor, control de acceso basado en roles y políticas formales de privacidad, retención y respuesta a incidentes. Trabajamos con investigadores de seguridad y mantenemos un programa de divulgación responsable.",
    "items": {
      "encryption": {
        "title": "Cifrado en reposo y en tránsito",
        "body": "AES-256-GCM en credenciales y columnas sensibles; TLS 1.3 end-to-end en el edge. Claves en variables de entorno, nunca en la base de datos."
      },
      "mfa": {
        "title": "MFA + RBAC obligatorios",
        "body": "TOTP (RFC 6238) obligatorio para owner, admin y developer. Control de acceso por rol con principio de mínimo privilegio, auditado anualmente."
      },
      "compliance": {
        "title": "GDPR / LGPD / CPRA alineado",
        "body": "Aviso de privacidad público, endpoints de exportación y eliminación de datos (derechos del titular), retención mínima por clase de dato, deauth del proveedor en hasta 24 h."
      },
      "scans": {
        "title": "Escaneos continuos",
        "body": "OWASP ZAP + Nuclei trimestrales y en cada release relevante. Dependabot activo. SLAs claros: crítico 7 d, alto 14 d, medio 30 d."
      },
      "disclosure": {
        "title": "Divulgación responsable",
        "body": "SECURITY.md público con ventana de 90 días para corrección. Trabajamos con investigadores externos y damos crédito a reportes válidos."
      },
      "researcher": {
        "title": "Investigadores de seguridad en el equipo",
        "body": "Tenemos investigadores de seguridad internos. Cada sistema se audita también desde la mirada del atacante."
      }
    }
  },
  "process": {
    "eyebrow": "Cómo trabajamos",
    "title": "Proceso predecible, entregas documentadas.",
    "lead": "Un flujo pensado para proyectos corporativos y del sector público — auditable, confiable y sin sorpresas en ninguna fase.",
    "steps": {
      "01": {
        "title": "Descubrimiento",
        "body": "Escuchamos antes de proponer. Mapeamos operaciones, objetivos de negocio y restricciones técnicas — incluyendo exigencias legales y de cumplimiento cuando aplica."
      },
      "02": {
        "title": "Planificación técnica",
        "body": "Arquitectura de la solución, definición de stack, plan de entregas y criterios de aceptación. Sin caja negra — cada decisión técnica documentada y justificada."
      },
      "03": {
        "title": "Desarrollo y homologación",
        "body": "Entregas incrementales, documentación técnica, pruebas automatizadas y revisión continua. Acompañas el sistema evolucionar desde el primer sprint hasta el deploy."
      },
      "04": {
        "title": "Operación, soporte y evolución",
        "body": "Hosting, monitoreo, soporte técnico y evolución continua — con SLA claro durante toda la vigencia del contrato."
      }
    }
  },
  "contact": {
    "eyebrow": "Contacto",
    "title": "Conversemos sobre tu proyecto.",
    "lead": "Cuéntanos sobre tu empresa, el problema operativo o la demanda del organismo — volvemos con un dictamen técnico inicial y un camino claro hacia la entrega, sin compromiso.",
    "send_email": "Enviar correo",
    "view_github": "Ver en GitHub",
    "labels": {
      "email": "Correo",
      "github": "GitHub",
      "address": "Dirección",
      "cnpj": "CNPJ"
    }
  },
  "footer": {
    "company_legal": "Niertech Tecnologias e Sistemas LTDA · CNPJ 64.745.677/0001-31",
    "copyright": "© {{year}} Niertech Solutions",
    "city": "São Paulo, Brasil"
  },
  "whatsapp": {
    "aria": "Habla con nosotros en WhatsApp",
    "message": "¡Hola! Me gustaría saber más sobre los servicios de Niertech."
  },
  "lang_switcher": {
    "aria": "Seleccionar idioma",
    "pt-BR": "Português",
    "en": "English",
    "es": "Español"
  }
}
